<p-dialog header="Déposer vos documents" [(visible)]="visible" [modal]="true" [closable]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '75vw' }" (onHide)="closeDialog()">
  <p-stepper [(value)]="stepItem" [linear]="true">
    <p-step-item [value]="1">
        <p-step>Sécurisation de votre document par téléphone</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
              <div class="flex justify-center" *ngIf="isLoadingUserInfo()">
                <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
              </div>

              <div class="mb-4">
                <p>
                  <strong>Pourquoi demander votre numéro de téléphone&nbsp;?</strong><br>
                  Pour sécuriser l'accès à votre document, nous vous demandons un numéro de portable. Ce numéro sera utilisé pour vérifier votre identité si vous souhaitez récupérer ce document ultérieurement. Il ne sera utilisé à aucune autre fin.
                </p>
              </div>
              <div class="mb-4">
                <label for="userPhone" class="block mb-2 font-semibold">Numéro de portable&nbsp;:</label>
                <input id="userPhone" name="userPhone" type="tel" class="p-inputtext p-component w-full"
                  aria-label="documentTel"
                  [(ngModel)]="documentTel"
                  required
                  pattern="^0[67]\d{8}$"
                  maxlength="10"
                  placeholder="0612345678"
                  [ngClass]="{'ng-invalid': documentTel && !validatorPhone(documentTel)}"
                />
                <div *ngIf="documentTel && !validatorPhone(documentTel)" class="text-red-500 text-sm mt-1">
                  Merci de saisir un numéro de portable valide de 10 chiffres commençant par 06 ou 07.
                </div>
              </div>
              <div class="py-6">
                  <p-button label="Suivant" (onClick)="goToStep(2);activateCallback(2)" severity="contrast" [disabled]="!validatorPhone(documentTel)"/>
              </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>
    <p-step-item [value]="2">
        <p-step>Choix de l'application</p-step>
        <p-step-panel>
            <ng-template #content let-activateCallback="activateCallback">
              <div class="flex justify-center" *ngIf="isLoadingUserInfo()">
                <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
              </div>
              <div *ngFor="let app of filteredApplications()" class="card shadow-2 p-4 w-100">
                <div class="flex items-center">
                  <p-checkbox class="mr-5" [(ngModel)]="checked" [binary]="true" (onChange)="onCheckboxChange(app.key, $event.checked);goToStep(2);activateCallback(3)"/>
                  <div class="flex items-center w-full">
                    <span class="w-16 h-16 mr-3 rounded-2xl bg-primary text-white flex items-center justify-center text-xl font-bold shrink-0 shadow-sm" [title]="app.name">
                      {{ getInitials(app.name) }}
                    </span>
                    <div>
                      <h4 class="text-left">{{ app.name }}</h4>
                      <p class="text-left text-sm text-700 mt-2">{{ app.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-6">
                  <p-button label="Suivant" (onClick)="goToStep(2);activateCallback(3)" severity="contrast" [disabled]="!selectedApp"/>
              </div>
            </ng-template>
        </p-step-panel>
    </p-step-item>
    <p-step-item [value]="3">
      <p-step>Choix du document</p-step>
      <p-step-panel>
          <ng-template #content let-activateCallback="activateCallback">
            <div class="card">

              <p-fileupload
                maxFileSize="78643200"
                (onSelect)="onSelectedFiles($event)"
                [multiple]="true"
                invalidFileSizeMessageSummary="Taille de fichier invalide"
                invalidFileSizeMessageDetail="La taille maximale est de 75 Mo"
                mode="advanced"
              >
                <ng-template
                    #header
                    let-files
                    let-chooseCallback="chooseCallback"
                >
                  <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
                      <div class="flex gap-2">
                          <p-button
                            label="Ajouter un document"
                            (onClick)="chooseCallback()"
                            icon="pi pi-plus"
                            [rounded]="true"
                            [outlined]="true"
                          />
                      </div>
                  </div>
                </ng-template>
                <ng-template
                  #content
                  let-files
                  let-removeFileCallback="removeFileCallback"
                >
                  <div class="flex flex-col gap-8 pt-4">
                      <div *ngIf="files?.length > 0">
                          <div class="flex flex-wrap gap-4">
                              <div
                                  *ngFor="let file of files; let i = index"
                                  class="p-8 rounded-border flex flex-col border border-surface items-center gap-4"
                              >
                                  <span
                                      class="font-semibold text-ellipsis max-w-60 whitespace-nowrap overflow-hidden"
                                      >{{ file.name }}</span
                                  >
                                  <div>{{ formatSize(file.size) }}</div>
                                  <p-button
                                      icon="pi pi-times"
                                      (click)="removeFileCallback()"
                                      [outlined]="true"
                                      [rounded]="true"
                                      severity="danger"
                                  />
                              </div>
                          </div>
                      </div>
                  </div>
                </ng-template>
                <ng-template #file> </ng-template>
                <ng-template #empty let-chooseCallback="chooseCallback">
                    <div class="flex items-center justify-center flex-col">
                        <i class="pi pi-cloud-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"></i>
                        <p class="mt-6 mb-0">Glissez vos fichiers ici</p>
                    </div>
                </ng-template>
              </p-fileupload>

          </div>
            <div class="py-6">
                <div class="flex justify-center mb-4" *ngIf="isUploading">
                  <p-progress-spinner strokeWidth="8" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
                  <span class="ml-3 flex items-center">Mise en ligne en cours...</span>
                </div>
                <p-button label="Enregister" severity="contrast" (onClick)="upload()" [disabled]="isUploading || !files.length"/>
            </div>
          </ng-template>
      </p-step-panel>
    </p-step-item>
  </p-stepper>
</p-dialog>
